import React from 'react'
import ReactLoading from 'react-loading'

const Loading = () => (
  <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <ReactLoading type={'bars'} color={'#16057C'} />
  </div>
)

export default Loading
